import React, { useState, useEffect } from "react";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import TrashIcon from "@mui/icons-material/DeleteRounded";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-hot-toast";
import { updateOrganization, fetchOrganizationUsers, inviteUser, deleteUser, updateUser, CopyUserInviteLink } from 'js/Api/index';
import { Button } from '../Component/CommonFormEle';

function ManageList({ org, onBackClick, onUpdateOrganization, currentUserRole, selectedTab, setSelectedTab, }) {
    const [editedOrg, setEditedOrg] = useState({
        ...org,
        organizationId: org.organizationId,
        name: org.name,
        address: org.address,
        phoneNumber: org.phoneNumber,
    });
    const [users, setUsers] = useState([]);
    const [showInviteModal, setShowInviteModal] = useState(false);
    const [newUser, setNewUser] = useState({ name: "", email: "", role: "" });
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [showEditUserModal, setShowEditUserModal] = useState(false);
    const [editedUser, setEditedUser] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const isManager = currentUserRole === "manager";
    const isStaff = currentUserRole === "staff";

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        const result = await fetchOrganizationUsers(org.id);
        if (result.success) {
            const usersWithStatus = result.data.map((user) => {
                const passwordHash = user.passwordHash || "";
                const status = passwordHash ? "active" : "pending";
                return { ...user, status };
            });
            setUsers(usersWithStatus);
        } else {
            console.error("Failed to fetch users:", result.error);
        }
    };

    const handleTabClick = (tab) => {
        setSelectedTab(tab);
        if (tab === "users") {
            loadUsers();
        }
    };

    const handleInputChange = (e) => {
        setEditedOrg({ ...editedOrg, [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
    };

    const handleSaveClick = async () => {
        const result = await updateOrganization(editedOrg.id, editedOrg);
        if (result.success) {
            onUpdateOrganization(editedOrg);
            toast.success(result.message);
        } else {
            toast.error(result.message);
        }
    };

    const handleInviteClick = () => {
        setShowInviteModal(true);
    };

    const handleUserInputChange = (e) => {
        setNewUser({ ...newUser, [e.target.name]: e.target.value });
    };

    const handleInviteSubmit = async (e) => {
        e.preventDefault();

        const userData = {
            organizationGuid: org.id,
            name: newUser.name,
            email: newUser.email,
            role: newUser.role,
        };

        const result = await inviteUser(userData);

        if (result.success) {
            const newUserWithStatus = {
                ...newUser,
                id: Date.now(),
                status: "pending",
            };
            setUsers([...users, newUserWithStatus]);
            setNewUser({ name: "", email: "", role: "" });
            setShowInviteModal(false);
            toast.success(result.message);
            loadUsers();
        } else {
            toast.error(result.error);
        }
    };

    const handleInviteCancel = () => {
        setShowInviteModal(false);
    };

    const handleDeleteUserClick = (userId) => {
        if (userId) {
            setDeleteUserId(userId);
            setShowDeleteModal(true);
        }
    };

    const handleDeleteUserConfirm = async () => {
        const result = await deleteUser(deleteUserId);

        if (result.success) {
            const updatedUsers = users.filter((user) => user.id !== deleteUserId);
            setUsers(updatedUsers);
            setDeleteUserId(null);
            toast.success(result.message);
            setShowDeleteModal(false);
            loadUsers();
        } else {
            toast.error(result.message);
        }
    };

    const handleDeleteUserCancel = () => {
        setShowDeleteModal(false);
    };

    const handleUserClick = (user) => {
        if (isStaff) return;
        setEditedUser(user);
        setShowEditUserModal(true);
    };

    const handleEditUserInputChange = (e) => {
        setEditedUser({ ...editedUser, [e.target.name]: e.target.value });
    };

    const handleEditUserSubmit = async (e) => {
        e.preventDefault();

        const userData = {
            name: editedUser.name,
            organizationGuid: org.id,
            role: editedUser.role,
        };

        const result = await updateUser(editedUser.userId, userData);

        if (result.success) {
            const updatedUsers = users.map((user) =>
                user.id === editedUser.id ? editedUser : user
            );
            setUsers(updatedUsers);
            setShowEditUserModal(false);
            toast.success(result.message);
            loadUsers();
        } else {
            toast.error(result.message);
        }
    };

    const handleEditUserCancel = () => {
        setShowEditUserModal(false);
    };

    const ClickUserInviteLink = async () => {
        const result = await CopyUserInviteLink(editedUser.userId)
        if (result.success) {
            let url = result.data.url;
            navigator.clipboard.writeText(url)
            toast.success("Invitation link copied to the clipboard");
        } else {
            toast.error(result.message);
        }
    }

    return (
        <div className="midde_cont">
            <div className="container-fluid">
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title" style={{ display: "flex", alignItems: "center" }} >
                            {isManager || isStaff ? null : (
                                <ArrowBackRoundedIcon
                                    onClick={onBackClick}
                                    sx={{
                                        fontSize: "1rem",
                                        color: "black",
                                        marginRight: "10px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            <h2 style={{ flex: "1" }}>{org.name}</h2>
                        </div>
                    </div>
                </div>
                <div class="white_shd full margin_bottom_30">
                    <div className="full inner_elements">
                        <div className="tabbar padding_infor_info">
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab1" role="tablist">
                                    <div className={`nav-item nav-link ${selectedTab === "users" ? "active" : ""}`} id="nav-users-tab" data-toggle="tab"
                                        role="tab" aria-controls="nav-users" aria-selected={selectedTab === "users"} onClick={() => handleTabClick("users")} >
                                        Users
                                    </div>
                                    <div className={`nav-item nav-link ${selectedTab === "details" ? "active" : ""}`} id="nav-details-tab"
                                        data-toggle="tab" role="tab" aria-controls="nav-details" aria-selected={selectedTab === "details"} onClick={() => handleTabClick("details")} >
                                        Details
                                    </div>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                <div className={`tab-pane fade ${selectedTab === "users" ? "show active" : ""}`} id="nav-users" role="tabpanel" aria-labelledby="nav-users-tab" >
                                    <div className="actions">
                                        {isStaff ? null : (
                                            <Button onClick={handleInviteClick} variant="action-popup">
                                                Invite +
                                            </Button>
                                        )}
                                    </div>
                                    <table className="table table-hover">
                                        <thead>
                                            <tr key="headers">
                                                <th key="Name">Name</th>
                                                <th key="Email">Email</th>
                                                <th key="Role">Role</th>
                                                <th key="Status">Status</th>
                                                {isStaff ? null : <th></th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.map((user) => (
                                                <tr key={user.id} onClick={() => handleUserClick(user)} >
                                                    <td>{user.name}</td>
                                                    <td>{user.email}</td>
                                                    <td>{user.role}</td>
                                                    <td className="status">
                                                        {user.passwordHash ? (
                                                            <span className="active">{user.status}</span>
                                                        ) : (
                                                            <span className="waiting">{user.status}</span>
                                                        )}
                                                    </td>
                                                    {isStaff ? null : (
                                                        <td>
                                                            <TrashIcon
                                                                sx={{
                                                                    fontSize: "1.5rem",
                                                                    color: "black",
                                                                    marginRight: "10px",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDeleteUserClick(user.userId);
                                                                }}
                                                            />
                                                            <EditIcon
                                                                sx={{
                                                                    fontSize: "1.5rem",
                                                                    color: "black",
                                                                    marginRight: "10px",
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className={`tab-pane fade ${selectedTab === "details" ? "show active" : ""}`} id="nav-details" role="tabpanel" aria-labelledby="nav-details-tab" >
                                    <div className="admin-details">
                                        <div className="col-md-7 col-lg-8">
                                            <form className="needs-validation" noValidate style={{ margin: "0px 0px 0px 0px" }} >
                                                <div className="row g-3">
                                                    <div className="col-12">
                                                        <label htmlFor="name" className="form-label">
                                                            Organisation Type : {editedOrg.orgType}
                                                        </label>
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="name">{editedOrg.orgType === "family" ? "Purchaser's Name" : "Name"}</label>
                                                        <div className="input-group has-validation">
                                                            <input type="text" className="form-control" name="name" value={editedOrg.name} onChange={handleInputChange} readOnly={isStaff} required />
                                                            <div className="invalid-feedback">
                                                                Organisation Name is required.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12" style={{ marginTop: "1em" }} >
                                                        <label htmlFor="organizationId">{editedOrg.orgType === "family" ? "Family Id" : "Organisation Id"}</label>
                                                        <input type="text" className="form-control" id="organizationId" name="organizationId" value={editedOrg.code} onChange={handleInputChange}
                                                            readOnly required />
                                                        <div className="invalid-feedback">
                                                            Please enter a valid Organisation ID.
                                                        </div>
                                                    </div>
                                                    {editedOrg.orgType === "family" ?
                                                        <div className="col-12" style={{ marginTop: "1em" }} >
                                                            <label htmlFor="contact" className="form-label">
                                                                Purchaser's Email Address
                                                            </label>
                                                            <input type="email" className="form-control" id="contact" name="contact" value={editedOrg.emailId} readOnly />
                                                            <div className="invalid-feedback">
                                                                Please enter a valid Contact Person.
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="col-12" style={{ marginTop: "1em" }} >
                                                            <label htmlFor="contact" className="form-label">
                                                                Contact Person
                                                            </label>
                                                            <input type="text" className="form-control" id="contact" name="contact" value={editedOrg.contact} onChange={handleInputChange}
                                                                readOnly={isStaff} required />
                                                            <div className="invalid-feedback">
                                                                Please enter a valid Contact Person.
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className="col-12" style={{ marginTop: "1em" }} >
                                                        <label htmlFor="phoneNumber" className="form-label" >
                                                            Phone Number
                                                        </label>
                                                        <input type="text" className="form-control" id="phoneNumber" name="phoneNumber"
                                                            value={editedOrg.phoneNumber} onChange={handleInputChange} readOnly={isStaff} required />
                                                        <div className="invalid-feedback">
                                                            Please enter a valid Phone Number.
                                                        </div>
                                                    </div>
                                                    {editedOrg.orgType === "family" ? null :
                                                        <>
                                                            <div className="col-12" style={{ marginTop: "1em" }} >
                                                                <label htmlFor="address" className="form-label">
                                                                    Address
                                                                </label>
                                                                <input type="text" className="form-control" id="address" name="address" value={editedOrg.address}
                                                                    onChange={handleInputChange} readOnly={isStaff} required />
                                                                <div className="invalid-feedback">
                                                                    Please enter a valid Address.
                                                                </div>
                                                            </div>

                                                            <div className="col-12" style={{ marginTop: "1em" }} >
                                                                <label htmlFor="address" className="form-label"> Policy Option (When a settings group is locked, also hide those settings on the CareWindow device and smartphone app)</label>
                                                                <br />
                                                                <input type="checkbox" id="policySettingLock" name="policySettingLock"
                                                                    checked={editedOrg.policySettingLock} onChange={handleInputChange} readOnly={isStaff} />
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <hr className="my-4" />
                                                {isStaff ? null : (
                                                    <Button onClick={handleSaveClick} variant="blue">
                                                        Save
                                                    </Button>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showInviteModal && (
                    <div className="modal" tabIndex={"-1"} role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ width: "400px" }}>
                                <div className="modal-header">
                                    <h1 className="modal-title">Invite User</h1>
                                    <Button onClick={handleInviteCancel} variant="modal-close">
                                        &times;
                                    </Button>
                                </div>
                                <div className="modal-body">
                                    <form className="contact-form">
                                        <div className="form-group">
                                            <label htmlFor="name">Name</label>
                                            <input className="form-control" type="text" id="name" name="name" value={newUser.name} onChange={handleUserInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email">Email</label>
                                            <input className="form-control" type="email" id="email" name="email" value={newUser.email} onChange={handleUserInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="role">Role</label>
                                            <select className="form-control" id="role" name="role" value={newUser.role} onChange={handleUserInputChange} required >
                                                <option value="">Select a role</option>
                                                <option value="Manager">Manager</option>
                                                <option value="Staff">Normal User</option>
                                            </select>
                                        </div>
                                        <div className="modal-footer">
                                            <Button onClick={handleInviteCancel} variant="cancel">
                                                Cancel
                                            </Button>
                                            <Button onClick={handleInviteSubmit} variant="blue">
                                                Invite
                                            </Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showDeleteModal && (
                    <div
                        className="modal fade show"
                        style={{ display: "block" }}
                        aria-modal="true"
                        role="dialog"
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title">Delete User</h1>
                                    <Button onClick={handleDeleteUserCancel} variant="modal-close">
                                        &times;
                                    </Button>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        Are you sure you want to delete{" "}
                                        <strong>
                                            {users.find((user) => user.userId === deleteUserId)?.name}
                                        </strong>
                                        ?
                                    </p>
                                </div>
                                <div className="modal-footer">
                                    <Button onClick={handleDeleteUserCancel} variant="cancel">
                                        Cancel
                                    </Button>
                                    <Button onClick={handleDeleteUserConfirm} variant="delete">
                                        Delete
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showEditUserModal && (
                    <div className="modal" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ width: "400px" }}>
                                <div className="modal-header">
                                    <h1 className=" modal-title">Edit User</h1>
                                    <Button onClick={handleEditUserCancel} variant="modal-close">
                                        &times;
                                    </Button>
                                </div>
                                <form className="contact-form">
                                    <div className="form-group" style={{ position: "relative" }}>
                                        <label htmlFor="staticEmail" className="col-form-label">
                                            Email:
                                        </label>
                                        <div>
                                            <input readOnly className="form-control-plaintext" id="staticEmail" type="text" name="email"
                                                value={editedUser.email} style={{ paddingLeft: "10px", backgroundColor: "#e9ecef", }} />
                                        </div>
                                        <span>
                                            <i className="fa fa-ban" style={{ position: "absolute", top: "75%", left: "93%", transform: "translateY(-50%)", pointerEvents: "none", }} ></i>
                                        </span>
                                    </div>

                                    <div className="form-group">
                                        <label>Name</label>
                                        <input className="form-control" type="text" name="name" value={editedUser.name} onChange={handleEditUserInputChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>Role</label>
                                        <select className="custom-select" name="role" value={editedUser.role} onChange={handleEditUserInputChange} >
                                            <option value="Manager">Manager</option>
                                            <option value="Staff">Normal User</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <button onClick={(e) => { e.preventDefault(); ClickUserInviteLink() }} type="button" className="btn cur-p btn-outline-dark" style={{ width: "50%" }} > Copy invitation link </button>
                                    </div>

                                    <div className="modal-footer">
                                        <Button onClick={handleEditUserCancel} variant="cancel">
                                            Cancel
                                        </Button>
                                        <Button onClick={handleEditUserSubmit} variant="blue">
                                            Save
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ManageList;